import { HttpClient, HttpParams } from "@angular/common/http";
import { AppConfig } from "../../app-config";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { Source } from "@pienso/ingest-types/source.interface";
import { map } from "rxjs/operators";
import { SourceDataService } from "./source-data.service";
import { DataSet, DataSetType } from "@pienso/ingest-types/entity";

@Injectable({ providedIn: "root" })
export class LibraryDataService {
  private http = inject(HttpClient);
  private config = inject(AppConfig);

  // getLibrary(includeSource: boolean, includeCorpus: boolean, includeTraining: boolean, limit = 0, offset = 0) {
  //   let types = (includeSource ? 's' : '') + (includeCorpus ? 'c' : '') + (includeTraining ? 't' : '');
  //   if (!types.length) {
  //     types = 'sc';
  //   }
  //   const params = new HttpParams();
  //   params.set('types', types);
  //   if (limit) {
  //     params.set('limit', '' + limit);
  //   }
  //   if (offset) {
  //     params.set('offset', '' + offset);
  //   }
  //   return this.http.get<any>(this.config.apiEndpoint + '/library');
  // }

  getLibrary(hidden: boolean = false): Observable<Source[]> {
    let params = new HttpParams().set("types", "sct");
    if (hidden) {
      params = params.set("hidden", "true");
    }
    return this.http
      .get<Source[]>(this.config.ingestApiEndpoint + "/library", { params })
      .pipe(map((sources: Source[]) => sources.map((s) => SourceDataService.hydrateSource(s))));
  }

  toggleHidden(dataSet: DataSet): Promise<any> {
    const partial = {
      id: dataSet.id,
      type: dataSet.type,
      hidden: !dataSet.hidden,
    };
    return this.updateEntity(partial);
  }

  async updateEntity<T extends Partial<DataSet> & { id: number; type: DataSetType }>(dataset: T): Promise<any> {
    return (
      this.http
        .put<DataSet>(this.config.ingestApiEndpoint + "/library", dataset)
        //   .pipe(
        //   map((ds) => {
        //     switch (ds.type) {
        //       case DataSetType.SOURCE:
        //         return SourceDataService.hydrateSource(ds as Source);
        //       case DataSetType.CORPUS:
        //         return CorpusDataService.hydrateCorpus(ds as Corpus);
        //       case DataSetType.PIF:
        //         return PifDataService.hydratePif(ds as Pif);
        //     }
        //   })
        // )
        .toPromise()
    );
  }
}
